import { translateError, setErrorDialog, serverUrl, getheader, getMethodByCallBack, cacheTypes, postMethodByCallBack, getMethodByDispatcher, postMethodByDispatcher } from "../../../store/api/CommonFunctions";
export function applyService(data, fn) {
  const _header = getheader()
  return dispatch => {

    dispatch({
      type: "LOADING",
      data: true
    });
    let serviceType = data.ServiceType;
    data = JSON.stringify(data)
    fetch(serverUrl + "ReceptionTasksApi/SaveService/", {
      body: data,
      headers: _header,
      method: 'POST',
      cache: "no-cache"
    })
      .then(res => res.json())
      .then(res => {

        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          setErrorDialog(dispatch, res.Message ?? "", "ثبت سرویس");
          return;
        }
        else if (res.Data?.SMSMessage?.length > 0) {
          setErrorDialog(dispatch, res.Data.SMSMessage);
        }
        else {
          setErrorDialog(dispatch, "success", "ثبت سرویس");
        }
        if (fn)
          fn(res, serviceType);
        return dispatch({
          type: "ADD_SERVICE",
          data: res
        })
      }
      ).catch(err => {
        console.error('[ADD_SERVICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  };
}
export function saveUsedProduct(data, fn, oldList, onError) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_USEDPARTS",
      data: "PENDING"
    });
    data = JSON.stringify(data)
    fetch(serverUrl + "api/ServiceUsedPartsAPI/SaveServiceUsedPart/", {
      body: data,
      headers: getheader(),
      method: 'POST',
      cache: 'no-cache'
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message || !res.List) {
          setErrorDialog(dispatch, res.Message, "ثبت قطعه مصرفی");
          if(onError)
          {
            onError();
          }
          dispatch({
            type: "GET_SERVICE_USEDPARTS",
            data: oldList
          })
          return;
        }
        dispatch({
          type: "GET_SERVICE_USEDPARTS",
          data: res.List
        })
        if (fn) {
          fn(res);
        }
      }
      ).catch(err => {
        console.error('[ADD_USED_PART]', err);
      });
  };
}
export function getserviceUsedParts(serviceID, serviceType) {

  return dispatch => {
    dispatch({
      type: "GET_SERVICE_USEDPARTS",
      data: "PENDING"
    })
    fetch(serverUrl + "api/ServiceUsedPartsAPI/GetServiceUsedParts?ServiceID=" + serviceID + '&ServiceType=' + serviceType, {
      headers: getheader(),
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        if (res.Message && res.Message === "Error") {
          alert("اشکال در بازیابی قطعات مصرفی");
          return;
        }
        return dispatch({
          type: "GET_SERVICE_USEDPARTS",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در بازیابی قطعات مصرفی");
      });

  };
}
////////////////////////////////////////////////////////////////////
export function getTaskList(pagenumber, pageSize) {
  var token = localStorage.getItem('token')
  return dispatch => {

    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + "ReceptionTasksApi/GetTasks/?pageSize=" + pageSize + '&PageNumber=' + pagenumber, {
      headers: {
        "Token": token
      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          if (res.Message === "Error") {
            setErrorDialog(dispatch, "اشکال در بازیابی اطلاعات", "کارتابل کارها");

          }
          else if (res.Message === "UserIsNotRelatedToStaff") {
            setErrorDialog(dispatch, "کاربر مورد نظر به تکنسین/پرسنل/نماینده ای متصل نیست", "کارتابل کارها");
          }
          res = null;
        }
        return dispatch({
          type: "GET_TASKS",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        setErrorDialog(dispatch, "اشکال در بازیابی اطلاعات", "کارتابل کارها");
      });

  };
}
export function getMyTaskList(data, setTotalCount) {

  return dispatch => {

    dispatch({
      type: "GET_MY_TASKS",
      data: 'PENDING'
    })
    dispatch({
      type: "SEARCH_SERVICE_FILTERS",
      data: data
    })
    fetch(serverUrl + "ReceptionTasksApi/GetMyTasks", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: 'POST'
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "جستجوی کارها")
          res = { Data: [], TotalCount: 0 };
        }
        else if (res.Tasks) {
          res.Data = res.Tasks;
        }
        if (setTotalCount) {
          if (res) {
            setTotalCount(res.TotalCount);
          }
          else {
            setTotalCount(0);
          }
        }
        return dispatch({
          type: "GET_MY_TASKS",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        return dispatch({
          type: "GET_MY_TASKS",
          data: null
        })
      });

  };
}
export function getServiceWatingList() {

  return dispatch => {

    dispatch({
      type: "GET_MY_TASKS",
      data: 'PENDING'
    })

    fetch(serverUrl + "api/ServiceReportsAPI/GetServiceWatingList", {
      headers: getheader(),
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "لیست انتظار")
          res = { Data: [], TotalCount: 0 };
        }
        else if (res.Tasks) {
          res.Data = res.Tasks;
          res.TotalCount = res.Tasks.length;
          dispatch({
            type: "SEARCH_SERVICE_FILTERS",
            data: { Take: res.TotalCount, Skip: 0 }
          })
        }
        return dispatch({
          type: "GET_MY_TASKS",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        return dispatch({
          type: "GET_MY_TASKS",
          data: null
        })
      });

  };
}
export function getServiceWatingForReceptionList(fn) {
  getMethodByCallBack("api/ServiceReportsAPI/GetServiceWatingForReceptionList", cacheTypes.NoCache, fn, "GET_SERVICE_WATING");
}
////////////////////////////////////////////////////////////////////////////////////
export function rejectService(serviceType, serviceID, rejectDesc, fn) {

  if (!rejectDesc || rejectDesc === "") {
    alert("ثبت دلیل رد الزامی است");
    return;
  }
  let token = localStorage.getItem("token");
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "ReceptionTasksApi/RejectService", {
      headers: {
        'Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ServiceID: serviceID, ServiceType: serviceType, RejectDesc: rejectDesc }),
      method: "POST",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (res === "Success") {
          alert("عملیات با موفقیت انجام شد");
          fn();
        }
        else {
          alert("اشکال در انجام عملیات");
        }
      }).catch(e =>
        console.log("[RejectService]", e))
  }
}
////////////////////////////////////////////////////////////////////
export function getService(serviceType, serviceID) {
  let token = localStorage.getItem('token');
  return dispatch => {

    if (serviceID === -1) {
      return dispatch({
        type: "GET_SERVICE",
        data: null
      })
    }
    dispatch({
      type: "GET_SERVICE",
      data: "Pending"
    })
    fetch(serverUrl + "ReceptionTasksApi/GetService?ServiceType=" + serviceType + "&&ServiceID=" + serviceID, {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات پذیرش");
          res = null;
        }
        if (res) {
          const productRequest = {
            ID: 0,
            CustomerName: res.CustomerName,
            CustomerId: res.CustomerID,
            ServiceNumber: res.InvoiceNumber,
            ServiceID: serviceID,
            ServiceType: serviceType,
            ProductName: res.ProductName,
            ProductModel: res.ProductModel,
            ProductSerial: res.SerialNumber,
            ProductID: res.ProductID,
            RequestAddress: res.ServiceAddress,
            StatusStr: "پیش نویس",
            StatusCode: '7',
            LastComment: ""
          };
          dispatch({
            type: "FETCH_Product_Request",
            data: productRequest
          })
        }
        return dispatch({
          type: "GET_SERVICE",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  }

};
export function getServiceWithCallBack(serviceType, serviceID, getData) {
  getData("Pending");

  fetch(serverUrl + "ReceptionTasksApi/GetService?ServiceType=" + serviceType + "&&ServiceID=" + serviceID, {
    headers: getheader(),
    method: 'GET',
    cache: 'no-cache'
  }).then(res => res.json())
    .then(res => {
      getData(res);

    }).catch(err => {
      console.error('[err]', err);
      getData(null);
      alert("اشکال در بازیابی اطلاعات");
    });
};
export function getLastServiceNumber(serviceType, getData) {
  getData("Pending");
  fetch(serverUrl + `ReceptionTasksApi/GetLastServiceNumber?serviceType=${serviceType}`, {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => {
      if (Number(res) > 0) {
        getData(Number(res));
      }
      else {
        getData(0);
      }
    })
}
////////////////////////////////////////////////////////////////////
export function getServiceReceipt(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_RECEIPT",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetServiceReceipt?serviceID=${serviceID}&serviceType=${serviceType}`, {
      headers: getheader(),
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "رسید تکنسین");
          res = null;
        }
        return dispatch({
          type: "GET_SERVICE_RECEIPT",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_RECEIPT]', err);
        setErrorDialog(dispatch, "اشکال در بازیابی رسید تکنسین", "رسید تکنسین");
      });
  }

};
export function getServiceInvoice(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_INVOICE",
      data: "PENDING"
    });
    fetch(serverUrl + "ReceptionTasksApi/GetServiceInvoice?serviceID=" + serviceID + "&serviceType=" + serviceType, {
      method: 'GET',
      cache: 'no-cache',
      headers: getheader()
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "فاکتور خدمات");
          res = null;
        }

        return dispatch({
          type: "GET_SERVICE_INVOICE",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_INVOICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در بازیابی اطلاعات");
      });
  }

};
export function getServiceTotalCost(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_TOTALCOST",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetServiceTotalCost?serviceID=${serviceID}&serviceType=${serviceType}`, {
      method: 'GET',
      cache: 'no-cache',
      headers: getheader()
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
          setErrorDialog(dispatch, res.Message, "فاکتور خدمات");
        }

        return dispatch({
          type: "GET_SERVICE_TOTALCOST",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_TOTALCOST]', err);
      });
  }

};
export function saveServiceInvoice(serviceType, serviceID, onSuccess) {
  return dispatch => {
    if (!serviceID || !serviceType) {
      return dispatch({
        type: "SAVE_SERVICE_INVOICE",
        data: "ServiceID_IS_UNDEFINED"
      });
    }
    dispatch({
      type: "SAVE_SERVICE_INVOICE",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/SaveServiceInvoice/${serviceType}/${serviceID}`, {
      headers: {
        "Token": localStorage.getItem("token"),
        "Content-Type": "application/json"
      },
      // body:{ serviceID: serviceID },
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (!res.status && res.Message === "Error") {
          alert("اشکال در ارتباط با سرور");
          return dispatch({
            type: "SAVE_SERVICE_INVOICE",
            data: "CONNECTION_ERROR"
          });
        }
        if (res.status === 400) {
          alert("اشکال در انجام عملیات");
          return dispatch({
            type: "SAVE_SERVICE_INVOICE",
            data: "Error"
          })
        }
        else {
          alert("عملیات با موفقیت انجام شد");
          return dispatch({
            type: "SAVE_SERVICE_INVOICE",
            data: "Success"
          });
        }
      }).catch(e => {
        console.log("[SAVE_SERVICE_INVOICE]", e);
      })
  }
}
////////////////////////////////////////////////////////////////////
export function deleteService(serviceType, serviceID, fn) {
  let token = localStorage.getItem('token');
  return dispatch => {
    if (serviceType === null || serviceType === '' || serviceType === undefined || serviceID === '' || serviceID === undefined || serviceID === null) {
      return dispatch({
        type: "DELETE_SERVICE",
        data: "NotFound"
      })
    }
    fetch(serverUrl + "ReceptionTasksApi/DeleteService?serviceType=" + serviceType + "&&serviceID=" + serviceID, {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف سرویس");
          return;
        }
        else {
          setErrorDialog(dispatch, "success", "حذف سرویس");
          if (fn) {
            fn();
          }
        }


      }).catch(err => {
        console.error('[DELETE_SERVICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در انجام اطلاعات");
      });
  }

};
export function deleteServiceUsedPart(id, fn) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_USEDPARTS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ServiceUsedPartsAPI/DeleteServiceUsedPart?ID=" + id, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message || !res.List) {
          setErrorDialog(dispatch, res.Message, "حذف قطعه مصرفی");
          return;
        }
        if (fn) {
          fn(res);
        }
        dispatch({
          type: "GET_SERVICE_USEDPARTS",
          data: res.List
        })
      }).catch(err => {
        console.log("[DELETE USEDPART]", err);
      })
  }
}
export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo) {
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
    return;
  }
  var formdata = new FormData();
  for (let i = 0; i < fileInput.files.length; i++) {
    formdata.append(fileInput.files[i].name, fileInput.files[i]);
    formdata.append("ParentID", parentID);
    formdata.append("AttachmentType", attachmentType);
  }
  if (moreInfo) {
    formdata.append("moreInfo", moreInfo);
  }
  var xhr = new XMLHttpRequest();
  xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
  xhr.setRequestHeader("token", localStorage.getItem("token"));
  xhr.setRequestHeader("NameIsUniq", true);
  xhr.send(formdata);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var response = JSON.parse(xhr.responseText);
      if (response.Message !== "Error") {
        alert("بارگذاری با موفقیت انجام شد");
        if (fn)
          fn();
      }
      else {
        alert("اشکال در آپلود فایل");
      }

    }
    return "UnExpected Error";

  };
}
export function attachSignature(parentID, parentType, signatureData, fn) {

  const formdata = new FormData();
  formdata.append("Signature_" + parentType + parentID + ".png", signatureData);
  formdata.append("ParentID", parentID);
  formdata.append("AttachmentType", parentType);
  formdata.append("IsForSignature", "true");
  var xhr = new XMLHttpRequest();
  xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
  xhr.setRequestHeader("NameIsUniq", true);
  xhr.send(formdata);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var response = JSON.parse(xhr.responseText);
      if (response.Message !== "Error") {
        //alert("ثبت با موفقیت انجام شد");
        if (fn)
          fn();
      }
      else {
        alert("اشکال در ثبت امضا");
      }

    }
    return "UnExpected Error";

  };
}
export function getServiceAttachments(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_ATTACHMENTS",
      data: 'PENDING'
    });
    fetch(serverUrl + `api/Attachments/GetAttachmentList?parentID=${serviceID}&attachmentType=${serviceType}`, {
      redirect: "follow",
      headers: getheader(),
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {

        if (!res) {
          return dispatch({
            type: "GET_SERVICE_ATTACHMENTS",
            data: null
          })
        }
        if (res.Message && res.Message === "Error") {
          alert("اشکال در بازیابی پیوست ها");
          return;
        }
        return dispatch({
          type: "GET_SERVICE_ATTACHMENTS",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_ATTACHMENTS]', err);
        dispatch({
          type: "GET_SERVICE_ATTACHMENTS",
          data: null
        });
      });
  }

};
export function downloadFile(itemID, attachmentType, onError) {
  //window.open(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`, "download");
  fetch(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`,
    {
      headers: {
        'Content-Type': 'blob',
        'token': localStorage.getItem("token")
      }
      , method: "get"
    })
    .then((response) => {
      response.blob()
        .then((blob) => {
          if (blob.type === "application/json") {
            blob.text().then(r => {
              const er = JSON.parse(r).Message;
              if (onError && er) {
                onError(er);
              }
            });
            return;
          }
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = "Download";
          a.click();
        })
    })
}
export function setRejectServicePopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_REJECTSERVICE_POPUP",
      data: status
    });
  }
}
export function deleteAttachment(id, type, onSuccess) {
  return dispatch => {
    dispatch({
      type: "DELETE_ATTACHMENT",
      data: "PENDING"
    });
    fetch(serverUrl + `api/Attachments/DeleteAttachment?id=${id}&attachmentType=${type}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Success") {
          setErrorDialog(dispatch, "success", "حذف فایل پیوست");
          if (onSuccess) {
            onSuccess();
          }
        }
        else {
          setErrorDialog(dispatch, res?.Message ?? "", "حذف فایل پیوست");
          return dispatch({
            type: "DELETE_ATTACHMENT",
            data: "ERROR"
          });
        }
      }).catch(e => {
        console.log("[DELETE_ATTACHMENT]", e);
        return dispatch({
          type: "DELETE_ATTACHMENT",
          data: "ERROR"
        });
      })
  }
}
export function setReferServicePopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_REFERSERVICE_POPUP",
      data: status
    });
  }
}
export function setSelectStaffPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_SELECTSTAFF_POPUP",
      data: status
    });
  }
}
export function setSerialHistoryPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_SERIALHISTORY_POPUP",
      data: status
    });
  }
}
export function setBorrowListPopup(status) {
  return dispatch => {
    dispatch({
      type: "SET_BORROW_LIST_POP",
      data: status
    })
  }
}
export function updateManageSendingStaff(data, fn) {
  postMethodByCallBack(`api/ManageSendingStaffAPI/UpdateManageSendingStaff`, data, fn, "UpdateManageSendingStaff");
}
export function getRelatedStaffsToAgent(data, onError) {
  if (!data) {
    data = {};
    data.Take = 10;
  }
  return dispatch => {
    dispatch({
      type: "GET_RELATEDSTAFFS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/StaffAPI/GetRelatedStaffsToAgent", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST",
      cache: "no-cache"

    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          onError(translateError(res.Message));
          res = [];
        }
        dispatch({
          type: "GET_RELATEDSTAFFS",
          data: res
        })
      }).catch(err => {
        dispatch({
          type: "GET_RELATEDSTAFFS",
          data: []
        });
        console.log("[GetRelatedStaffsForAgent]", err)
      })
  }
}
export function getAgentList(data) {
  if (!data) {
    data = {};
  }
  return dispatch => {
    dispatch({
      type: "GET_AGENT_LIST",
      data: "PENDING"
    });
    fetch(serverUrl + "api/StaffAPI/GetAgentList", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST",
      cache: "no-cache"

    }).then(res => res.json())
      .then(res => {
        if (res.Message === "Error") {
          res = null;
        }
        dispatch({
          type: "GET_AGENT_LIST",
          data: res
        })
      }).catch(err => {
        dispatch({
          type: "GET_AGENT_LIST",
          data: null
        });
        console.log("[GET_AGENCT_LIST]", err)
      })
  }
}
export function getServiceCountReport() {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (token === null || sUrl === null) {
    return dispatch => {
      return dispatch({
        type: "GET_SERVICE_COUNT",
        data: []
      });
    }
  }
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(sUrl + "api/ServiceReportsAPI/GetServiceCountReport?agencyID=null&&staffID=0", {
      headers: {
        'Token': token
      },
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        });
        return dispatch({
          type: "GET_SERVICE_COUNT",
          data: res
        });

      }
      ).catch(error => console.log("GETServiceCountReport", error))
  }
}
export function getTotalServiceCountByMonthOrYear(monthly, persianYear, onGetData) {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (token === null || sUrl === null) {
    onGetData([]);
  }
  onGetData("PENDING");
  fetch(sUrl + `api/ServiceReportsAPI/GetTotalServiceCountByMonthOrYear?monthly=${monthly}&&persianYear=${persianYear}`, {
    headers: {
      'Token': token
    },
    method: "GET",
    cache: "default"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        onGetData(translateError(res.Message));
      }
      else {
        onGetData(res);
      }
    }
    ).catch(error => console.log("GETServiceCountReport", error))
}
export function getServiceDeadlineReport() {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (token === null || sUrl === null) {
    return dispatch => {
      return dispatch({
        type: "SERVICE_DEADLINE",
        data: ""
      });
    }
  }
  return dispatch => {
    dispatch({
      type: "SERVICE_DEADLINE",
      data: "pending"
    });
    fetch(sUrl + "api/ServiceReportsAPI/GetServiceDeadlineReport?staffID=0&agencyID=null", {
      headers: {
        'Token': token
      },
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.status === 400) {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "SERVICE_DEADLINE_REPORT",
            data: []
          });
        }
        else {
          dispatch({
            type: "SERVICE_DEADLINE_REPORT",
            data: res
          });
        }
      }
      ).catch(er => {
        console.log("[SERVICE_DEADLINE_REPORT]", er);
        dispatch({
          type: "SERVICE_DEADLINE_REPORT",
          data: []
        });
      });
  }
}
export function getServiceDeadlineReportByCallback(onGet) {
  getMethodByCallBack("api/ServiceReportsAPI/GetServiceDeadlineReport?staffID=0&agencyID=null", cacheTypes.NoCache, onGet, "GetServiceDeadlineReport");
}
export function getStaffTotalFunctions() {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (token === null || sUrl === null) {
    return dispatch => {
      dispatch({
        type: "STAFF_TOTAL_FUNCTION",
        data: ""
      });
    }
  }
  return dispatch => {
    dispatch({
      type: "STAFF_TOTAL_FUNCTION",
      data: "pending"
    });
    fetch(sUrl + "api/ServiceReportsAPI/GetStaffTotalFunctions?staffID=0&agencyID=null", {
      headers: {
        'Token': localStorage.getItem("token")
      },
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.status === 400) {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "STAFF_TOTAL_FUNCTION",
            data: []
          });
        }
        else {
          dispatch({
            type: "STAFF_TOTAL_FUNCTION",
            data: res
          });
        }
      }
      ).catch(er => {
        console.log("[STAFF_TOTAL_FUNCTION]", er);
        dispatch({
          type: "STAFF_TOTAL_FUNCTION",
          data: []
        });
      });
  }
}
export function getStaffReportList() {
  return dispatch => {
    fetch(serverUrl + "StaffReportBySMSAPI/StaffReportBySMSServiceSelectAll", {
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "GET_STAFF_REPORT",
          data: res
        })
      })
  }
}
export function getSerialHistory(serial, cardNo, customerCode, productCode) {

  return dispatch => {
    if (!serial && !cardNo && !customerCode && !productCode) {
      alert("هیچکدام از فیلدهای جستجو پر نشده است");
      return dispatch({
        type: "GET_SERIAL_HISTORY",
        data: []
      });
    }
    dispatch({
      type: "GET_SERIAL_HISTORY",
      data: "PENDING"
    });
    fetch(serverUrl + `api/GuarantyAPI/GetSerialHistory?serial=${serial ?? -1}&cardNo=${cardNo ?? -1}&customerCode=${customerCode ?? -1}&productCode=${productCode ?? -1}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (!res || res.status === "404" || res.status === "400") {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "GET_SERIAL_HISTORY",
            data: []
          });
          return;
        }
        if (res && !res.status && res === "Error") {
          alert("اشکال در ارتباط با سرور");
          dispatch({
            type: "GET_SERIAL_HISTORY",
            data: []
          });
          return;
        }
        dispatch({
          type: "GET_SERIAL_HISTORY",
          data: res
        })
      }

      ).catch(e => {
        dispatch({
          type: "GET_SERIAL_HISTORY",
          data: "PENDING"
        });
        console.log("[GET_SERIAL_HISTORY]", e)
      });
  }
}
export function sendServiceInvoiceSMS(serviceType, serviceID, mobile) {
  if (!mobile || mobile.length < 10) {
    alert("موبایل مشتری معتبر نیست");
    return;
  }
  fetch(serverUrl + `ReceptionTasksApi/SendServiceInvoiceSMS?serviceType=${serviceType}&serviceID=${serviceID}&mobile=${mobile}`, {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => { alert("پیامک یا موفقیت ارسال شد"); })
    .catch(e => {
      console.log("SendInvoiceSMS:", e);
      alert("اشکال در ارسال پیامک")
    })
}
export function addNewRepairBug(repairID, bugId, onSuccess) {
  getMethodByCallBack(`ReceptionTasksApi/AddNewRepairBug?repairID=${repairID}&bugId=${bugId}`, cacheTypes.NoCache, onSuccess, "AddNewRepairBug");
}
export function getRepairBugList(repairID) {
  return dispatch => {
    dispatch({
      type: "GET_REPAIR_BUGS",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetRepairBugList?repairID=${repairID}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          setErrorDialog(dispatch, res?.Message ?? res, "فهرست ایرادها");
          res = null;
        }
        return dispatch({
          type: "GET_REPAIR_BUGS",
          data: res
        });

      }).catch(e => {
        console.log("[error]", e?.message);
        return dispatch({
          type: "GET_REPAIR_BUGS",
          data: null
        });
      })
  }
}
export function deleteRepairBug(bugId, onSuccess) {
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/DeleteRepairBug?Id=${bugId}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          alert("اشکال در انجام عملیات");
          return;
        }
        if (res === "Success") {
          alert("عملیات با موفقیت انجام شد");
          if (onSuccess) {
            onSuccess();
          }
        }
      }).catch(e => {
        alert("اشکال در انجام عملیات");
        console.log("[ADD_New_BUG]", e);
      })
  }
}
export function setCustomerFaultsPop(status) {
  return dispatch =>
    dispatch({
      type: "SET_CUSTOMER_FAULTS",
      data: status
    })
}
export function loadFaultsByCustomer(name) {
  return dispatch => {
    dispatch({
      type: "LOAD_FAULTS_CUSTOMER",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/LoadFaultsByCustomer?name=${name}`, {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          alert("اشکال در بازیابی اطلاعات");
          res = null
        }
        dispatch({
          type: "LOAD_FAULTS_CUSTOMER",
          data: res
        })
      }).catch(e =>
        dispatch({
          type: "LOAD_FAULTS_CUSTOMER",
          data: null
        })
      )
  }
}
export function getServiceStatusList() {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_STATUS",
      data: "PENDING"
    });
    fetch(serverUrl + "ReceptionTasksApi/GetServiceStatusList", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json()).then(res => {
      if (res === "Error" || res.Message) {
        res = null;
      }
      dispatch({
        type: "GET_SERVICE_STATUS",
        data: res
      });
    }).catch(e => {
      console.log("[GET_SERVICE_STATUS]", e);
      dispatch({
        type: "GET_SERVICE_STATUS",
        data: null
      });
    })
  }
}
export function setSignaturePop(status) {
  return dispatch => {
    dispatch({
      type: "SIGNATURE_POP",
      data: status
    });
  }
}
export function archiveService(serviceType, serviceID, fn) {
  return dispatch => {
    dispatch({
      type: "ARCHIVE_SERVICE",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksAPI/ArchiveService?serviceType=${serviceType}&serviceID=${serviceID}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "ARCHIVE_SERVICE",
          data: "DONE"
        });
        if (res.Message) {
          setErrorDialog(dispatch, res.Message ?? "", "ثبت سرویس");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت سرویس");
        fn();
      }).catch(err => {
        dispatch({
          type: "ARCHIVE_SERVICE",
          data: "DONE"
        });
        console.log("[ARCHIVE_SERVICE]", err);
      })
  }
}
export function removeArchiveService(serviceType, serviceID, fn) {
  getMethodByCallBack(`ReceptionTasksAPI/RemoveArchiveService?serviceType=${serviceType}&serviceID=${serviceID}`, cacheTypes.NoCache, fn, "RemoveArchiveService");
}
export function changeServiceStatus(serviceType, serviceID, statusID, fn) {
  getMethodByCallBack(`ReceptionTasksAPI/ChangeServiceStatus?serviceType=${serviceType}&serviceID=${serviceID}&statusID=${statusID}`, cacheTypes.NoCache, fn, "ChangeServiceStatus");
}
export function getMessageList(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "SERVICE_MESSAGE_LIST",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetServiceMessageList?serviceID=${serviceID}&serviceType=${serviceType}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "SERVICE_MESSAGE_LIST",
          data: res
        });
      }).catch(e => {
        console.log("[SERVICE_MESSAGE_LIST]", e);
      })
  }
}
export function addNewMessage(data, fn) {
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/AddServiceMessage`, {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data),
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت پیام سرویس");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت پیام سرویس");
        dispatch({
          type: "SERVICE_MESSAGE_LIST",
          data: res
        });
        if (fn) {
          fn(res);
        }
      }).catch(e => {
        console.log("[AddServiceMessage]", e);
      })
  }
}
export function deleteMessage(id, fn) {
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/DeleteServiceMessage`, {
      headers: getheader(),
      method: "POST",
      body: id,
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف پیام سرویس");
          return;
        }
        dispatch({
          type: "SERVICE_MESSAGE_LIST",
          data: res
        });
        setErrorDialog(dispatch, "success", "حذف پیام سرویس");
        if (fn) {
          fn(res);
        }
      }).catch(e => {
        console.log("[DeleteServiceMessage]", e);
      })
  }
}
export function getServiceStaffPayments(serviceID, serviceType) {
  return dispatch => {
    dispatch(getMethodByDispatcher(`ReceptionTasksAPI/GetServiceStaffPayments?serviceID=${serviceID}&serviceType=${serviceType}`, "SERVICE_STAFF_PAYMENTS", cacheTypes.NoCache, "دریافت اطلاعات"))
  }
}
export function updateServicePayments(data) {
  return dispatch => {
    dispatch({
      type: "SERVICE_STAFF_PAYMENTS",
      data: "PENDING"
    });
    const onPost = (res) => {
      if (res.Message || res.Error) {
        setErrorDialog(dispatch, res.Message ?? res.Error, "پرداختی سرویس");
        return;
      }
      setErrorDialog(dispatch, "success", "پرداختی سرویس");
      dispatch({
        type: "SERVICE_STAFF_PAYMENTS",
        data: res
      })
    }
    postMethodByCallBack("ReceptionTasksAPI/UpdateServicePayments", data, onPost, "UPDATE_SERVICE_PAYMENTS");
  }
}
export function getMainCompanies(onGetData) {
  getMethodByCallBack("api/CustomersAPI/GetMainCompanies", cacheTypes.NoCache, onGetData, "GetMainCompanies");
}
export function getCustomerRequestWithoutLoginList(data, onGet) {
  return dispatch => {
    dispatch({
      type: "CUST_REQ_LOGIN_FILTERS",
      data: data
    })
    dispatch(postMethodByDispatcher(`api/CustomersAPI/GetCustomerRequestWithoutLoginList?newOnes=${data.NewOnes}&take=${data.Take ?? 0}&skip=${data.Skip ?? 0}`, data, "GET_CUST_REQ_WITHOUT_LOGIN", "لیست درخواستهای سریع مشتریان", onGet));
  }

}
export function convertCustomerRequestToService(requestID, onDone) {
  getMethodByCallBack(`ReceptionTasksApi/ConvertCustomerRequestToService?requestID=${requestID}`, cacheTypes.NoCache, onDone, "ConvertCustomerRequestToService");
}
export function convertCustomerRequestToComplaint(requestID, onDone) {
  getMethodByCallBack(`ReceptionTasksApi/ConvertCustomerRequestToComplaint?requestID=${requestID}`, cacheTypes.NoCache, onDone, "ConvertCustomerRequestToComplaint");
}
export function deleteCustomerRequestwithoutLogin(requestID, onDelete) {
  getMethodByCallBack(`api/CustomersAPI/DeleteCustomerRequestWithoutLogin?requestID=${requestID}`, cacheTypes.NoCache, onDelete, "DeleteCustomerRequestWithoutLogin");
}
export function getStaffShare(staffShares, costType, discount, serviceCost, settings, receptionInAgent, agencyID) {
  const type1ServiceDiscountAffectOnStaffShare = Array.isArray(settings) && settings.find(s => s.SettingName === "Services_Type1_ServiceDiscountAffectOnStaffShareID")?.SettingValue;
  const type3ServiceDiscountAffectOnStaffShare = Array.isArray(settings) && settings.find(s => s.SettingName === "Services_Type3_ServiceDiscountAffectOnStaffShareID")?.SettingValue;

  let serviceCostAfterDiscount = Number(serviceCost);
  if (!(Number(agencyID) > 0) && Number(type1ServiceDiscountAffectOnStaffShare) === 0)
    serviceCostAfterDiscount = Number(serviceCost) - Number(discount);
  else if (Number(agencyID) > 0 && !receptionInAgent && Number(type3ServiceDiscountAffectOnStaffShare) === 0)
    serviceCostAfterDiscount = Number(serviceCost) - Number(discount);
  let staffShare = 0;
  if (costType === "defined") {
    if (!(Number(agencyID) > 0) || (Number(agencyID) > 0 && !receptionInAgent)) {
      staffShare = serviceCostAfterDiscount * Number(staffShares.StaffServiceCostPercentShare) / 100;
      staffShare += Number(staffShares.StaffServiceCostFixAmountShare);
    }
  }
  else if (costType === "extra") {
    if (Number(agencyID) > 0 || (!(Number(agencyID) > 0) && !receptionInAgent)) {
      staffShare = serviceCostAfterDiscount * Number(staffShares.StaffExtraServicesCostPercentShare) / 100;
      staffShare += Number(staffShares.StaffExtraServicesCostFixAmountShare);
    }
  }
  else if (costType === "referral") {
    if (Number(agencyID) > 0 || (!(Number(agencyID) > 0) && !receptionInAgent)) {
      staffShare = serviceCostAfterDiscount * Number(staffShares.StaffTransportationPercentShare) / 100;
      staffShare += Number(staffShares.StaffTransportationFixAmountShare);
    }
  }
  else if (costType === "mainCo") {
    if (Number(agencyID) > 0 || (!(Number(agencyID) > 0) && !receptionInAgent)) {
      staffShare = serviceCostAfterDiscount * Number(staffShares.StaffMainCoAmountPaymentPercentShare) / 100;
      staffShare += Number(staffShares.StaffMainCoAmountPaymentFixAmountShare);
    }
  }
  return staffShare;
}
export function serviceRejectHistory(data, onGet) {
  return dispatch =>
    dispatch(postMethodByDispatcher(`ReceptionTasksAPI/ServiceRejectHistory`, data, "SERVICE_REJECT_HISTORY", "تاریخچه انصراف تکنسین ها", onGet));
}
export function addOrUpdateTransportChart(data, onDone) {
  postMethodByCallBack(`ReceptionTasksAPI/AddOrUpdateTransportChart`, data, onDone, "AddOrUpdateTransportChart");
}
export function deleteTransportChart(id, onDelete) {
  getMethodByCallBack(`ReceptionTasksAPI/DeleteTransportChart?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteTransportChart");
}
export function getTransportationChartList(zoneID, onGet) {
  getMethodByCallBack(`ReceptionTasksAPI/GetTransportationChartList?zoneID=${zoneID}`, cacheTypes.NoCache, onGet, "GetTransportationChartList");
}

export function getManageSendingStaffList(data, onGetData) {
  return dispatch => {
    dispatch({
      type: "GET_MSS_FILTERS",
      data: data
    })
    dispatch(postMethodByDispatcher(`api/ManageSendingStaffAPI/GetManageSendingStaffList`, data, "GET_MSS_LIST", "اعزام تکنسین", onGetData));
  }
}
export function sendStaff(data, onSend) {
  postMethodByCallBack('api/ManageSendingStaffAPI/SendStaff', data, onSend, "SendStaff");
}
export function getProductBugDetailedReport(data, onGet) {

  return dispatch => {
    dispatch({
      type: "PRD_BUG_DTL_REP_FILTER",
      data: data
    })
    dispatch(postMethodByDispatcher(`api/ServiceReportsAPI/GetProductBugDetailedReport`, data, "PRD_BUG_DTL_REP", "گزارش ایرادات", onGet))
  }
}
export function getProductBugReport(data, groupByProductType, onGet) {

  return dispatch => {
    dispatch({
      type: "PRD_BUG_DTL_REP_FILTER",
      data: data
    })
    dispatch(postMethodByDispatcher(`api/ServiceReportsAPI/GetProductBugReport?groupByProductType=${groupByProductType}`, data, "PRD_BUG_REP", "گزارش ایرادات", onGet))
  }
}
export function getProductBugReportWithCallback(data, groupByProductType, onGet) {

  postMethodByCallBack(`api/ServiceReportsAPI/GetProductBugReport?groupByProductType=${groupByProductType}`, data, onGet, "PRD_BUG_REP");

}
export function getUsedPartsCountReport(data, onGet) {
  return dispatch => {
    dispatch({
      type: "UP_COUNT_REP_FILTER",
      data: data
    });
    dispatch(getMethodByDispatcher(`api/ServiceReportsAPI/GetUsedPartsCountReport?dateFrom=${data.DateFrom}&dateTo=${data.DateTo}`, data, "UP_COUNT_REP", "گزارش قطعات مصرفی", onGet));
  }
}
export function getDefinedServiceCostDetailed(data, onGet) {
  return dispatch => {
    dispatch({
      type: "DEF_SRV_COST_DTL_FILTER",
      data: data
    })
    dispatch(postMethodByDispatcher(`api/ServiceReportsAPI/GetDefinedServiceCostDetailed`, data, "DEF_SRV_COST_DTL", "گزارش خدمات و تعرفه ها", onGet));
  }
}
export function getDefinedServiceCostAggregate(data, onGet) {
  return dispatch => {
    dispatch({
      type: "DEF_SRV_COST_AGG_FILTER",
      data: data
    })
    dispatch(postMethodByDispatcher(`api/ServiceReportsAPI/GetDefinedServiceCostAggregate`, data, "DEF_SRV_COST_AGG", "گزارش خدمات و تعرفه ها", onGet));
  }
}
export function getStaffPerformance_ServiceTotalCost(data, onGet) {
  return dispatch => {
    dispatch({
      type: "STAFF_SRV_TOTAL_COST_FILTER",
      data: data
    })
    dispatch(postMethodByDispatcher(`api/ServiceReportsAPI/GetStaffPerformance_ServiceTotalCost`, data, "STAFF_SRV_TOTAL_COST", "گزارش عملکرد تکنسین-مجموع ریالی"));
  }
}
export function getStaffPerformance_ServiceTotalCostMonthly(staffID) {
  return dispatch => {
    dispatch(getMethodByDispatcher(`api/ServiceReportsAPI/GetStaffPerformance_ServiceTotalCostMonthly?staffID=${staffID}&persianYear=''`, "STAFF_SRV_TOTAL_COST_MONTHLY", cacheTypes.NoCache, "گزارش عملکرد تکنسین-ماهانه"));
  }
}
export function getStaffPerformance_ServiceCostList(data, onGet) {
  return dispatch => {
    dispatch({
      type: "STAFF_SRV_COST_LIST_FILTER",
      data: data
    })
    dispatch(postMethodByDispatcher(`api/ServiceReportsAPI/GetStaffPerformance_ServiceCostList`, data, "STAFF_SRV_COST_LIST", "گزارش عملکرد تکنسین-لیستی", onGet));
  }
}
export function getStaffPerformance_MyServiceCostList(data, onGet) {
  return dispatch => {
    dispatch(postMethodByDispatcher(`api/ServiceReportsAPI/GetStaffPerformance_MyServiceCostList`, data, "STAFF_MY_SRV_COST_LIST", "گزارش عملکرد من", onGet));
  }
}
export function getServiceAccountingList(data, onGet) {
  return dispatch => {
    dispatch({
      type: "SRV_ACC_LIST_FILTER",
      data: data
    });
    dispatch(postMethodByDispatcher("api/ServiceReportsAPI/GetServiceAccountingList", data, "SRV_ACC_LIST"));
  }
}
export function getServiceCostAndIncome(data) {
  return dispatch => {
    dispatch({
      type: "SRV_COST_INCOME_FILTER",
      data: data
    });
    dispatch(postMethodByDispatcher("api/ServiceReportsAPI/GetServiceCostAndIncome", data, "SRV_COST_INCOME"));
  }
}
export function getServiceCostAndIncomeByProduct(data) {
  return dispatch => {
    dispatch({
      type: "SRV_COST_INCOME_PRODUCT_FILTER",
      data: data
    });
    dispatch(postMethodByDispatcher("api/ServiceReportsAPI/GetServiceCostAndIncomeByProduct", data, "SRV_COST_INCOME_PRODUCT"));
  }
}
export function getServiceCostAndIncomeByProductType(data) {
  return dispatch => {
    dispatch({
      type: "SRV_COST_INCOME_FILTER",
      data: data
    });
    dispatch(postMethodByDispatcher("api/ServiceReportsAPI/GetServiceCostAndIncomeByProductType", data, "SRV_COST_INCOME_PTYPE"));
  }
}
export function getServiceAccountingListByProductType(data) {
  return dispatch => {
    dispatch({
      type: "SRV_ACC_LIST_FILTER",
      data: data
    });
    dispatch(postMethodByDispatcher("api/ServiceReportsAPI/GetServiceAccountingListByProductType", data, "SRV_ACC_LIST_PTYPE"));
  }
}
export function getServiceStatusListForManage(onGet) {
  getMethodByCallBack(`ReceptionTasksApi/GetServiceStatusListForManage`, cacheTypes.NoCache, onGet, "GetServiceStatusListForManage");
}
export function deleteServiceStatus(id, onDelete) {
  getMethodByCallBack(`ReceptionTasksApi/DeleteServiceStatus?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteServiceStatus");
}
export function addOrUpdateServiceStatus(data, onAddUpdate) {
  postMethodByCallBack(`ReceptionTasksApi/AddOrUpdateServiceStatus`, data, onAddUpdate, "AddOrUpdateServiceStatus");
}
export function getServiceCountByStatus(data, onGet) {
  postMethodByCallBack(`api/ServiceReportsAPI/GetServiceCountByStatus`, data, onGet, "");
}
export function getServiceCountByConsider(data, onGet) {
  postMethodByCallBack("api/ServiceReportsAPI/GetServiceCountByConsider", data, onGet, "");
}
export function getServiceCountByStage(staffID, dateFrom, dateTo, aDateFrom, aDateTo, onGet) {
  postMethodByCallBack(`api/ServiceReportsAPI/GetServiceCountByStage?dateFrom=${dateFrom}&dateTo=${dateTo}&aDateFrom=${aDateFrom}&aDateTo=${aDateTo}`, staffID, onGet, "");
}
export function getCustomerServiceCount(customerCode, onGet) {
  getMethodByCallBack(`ReceptionTasksApi/GetCustomerServiceCountAndRemainedsAcc?customerCode=${customerCode}`, cacheTypes.NoCache, onGet, "GetCustomerServiceCountAndRemainedsAcc")
}
export function getCustomerServiceCountByID(customerID, onGet) {
  getMethodByCallBack(`ReceptionTasksApi/GetCustomerServiceCountAndRemainedsAcc?customerID=${customerID}`, cacheTypes.NoCache, onGet, "GetCustomerServiceCountAndRemainedsAcc")
}
export function sendOrDeliverProduct(data, onDone) {
  postMethodByCallBack(`ReceptionTasksApi/SendOrDeliverProduct`, data, onDone, "SendOrDeliverProduct");
}
export function saAccountsBookReport(data) {
  return dispatch => {
    dispatch({
      type: "SA_ACCOUNTS_BOOK_FILTERS",
      data: data
    })
    dispatch(postMethodByDispatcher("api/DocumentsAPI/StaffAgencyAccountingBook", data, "SA_ACCOUNTS_BOOK_REPORT", "ریز حساب"));
  }
}
export function getSwappedSerialsReport(data) {
  return dispatch => {
    dispatch({
      type: "SWAPPED_SERIALS_REPORT_FILTERS",
      data: data
    });
    dispatch(postMethodByDispatcher("api/ServiceReportsAPI/GetSwappedSerialsReport", data, "SWAPPED_SERIALS_REPORT", "گزارش سریالهای تعویض شده"));
  }
}
export function updateServiceConsideration(serviceType, serviceID, considerID, onUpdate) {
  getMethodByCallBack(`ReceptionTasksApi/UpdateServiceConsideration?serviceType=${serviceType}&serviceID=${serviceID}&considerID=${considerID}`, cacheTypes.NoCache, onUpdate, "UpdateServiceConsideration");
}
export function getServiceStageAndStatusReport(data) {
  return dispatch => {
    dispatch({
      type: "SRV_STAGE_STATUS_FILTER",
      data: data
    });
    dispatch(postMethodByDispatcher("api/ServiceReportsAPI/GetServiceStageAndStatusReport", data, "SRV_STAGE_STATUS_REPORT"));
  }
}
export function getVIPServiceList(data) {
  return dispatch => {
    dispatch(postMethodByDispatcher("ReceptionTasksAPI/GetVIPServiceList", data, "VIP_SERVICE_LIST", "فهرست سرویس های ویژه"));
  }
}
export function searchCyclicServices(data) {
  return dispatch => {
    dispatch({
      type:"CYCLIC_SERVICES_FILTERS",
      data:data
    })
    dispatch(postMethodByDispatcher("ReceptionTasksAPI/SearchCyclicServices", data, "CYCLIC_SERVICE_LIST", "فهرست سرویس های دوره ای"));
  }
}
/**
 * 
 * @param {string} serviceType values: install/repair
 * @param {int} serviceID 
 * @param {string} actionType values: postpone/createnew/cancel 
 * @param {datetime} date 
 * @param {function} onChange 
 */
export function changeVIPServiceStatus(serviceType, serviceID, actionType, date, onChange)
{
  getMethodByCallBack(`ReceptionTasksAPI/ChangeVIPServiceStatus?serviceType=${serviceType}&serviceID=${serviceID}&actionType=${actionType}&date=${date}`, cacheTypes.NoCache, onChange, "ChangeVIPServiceStatus");
}
/**
 * 
 * @param {object} reportData 
 * @param {function} onGetData 
 */
export function getReportGeneratorReportData(reportData, onGetData)
{
  postMethodByCallBack("api/ServiceReportsAPI/GetReportGeneratorReport", reportData, onGetData,"GetReportGeneratorReport");
}
/**
 * 
 * @param {object} data 
 * @param {function} onSaveData 
 */
export function saveReportGeneratorTemplate(data, onSaveData)
{
  postMethodByCallBack("api/ServiceReportsAPI/SaveReportGeneratorTemplate", data, onSaveData,"SaveReportGeneratorTemplate");
}
/**
 * 
 * @param {function} onGet 
 */
export function getReportGeneratorTemplates(onGet)
{
  getMethodByCallBack("api/ServiceReportsAPI/GetReportGeneratorTemplates", cacheTypes.NoCache, onGet, "GetReportGeneratorTemplates");
}
/**
 * @param {int} id 
 * @param {function} onDelete 
 */
export function deleteReportGeneratorTemplate(id , onDelete)
{
  getMethodByCallBack(`api/ServiceReportsAPI/DeleteReportGeneratorTemplate?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteReportGeneratorTemplate"); 
}
export function stopService(serviceType, serviceID, stopDesc, onStopDone)
{
  postMethodByCallBack(`ReceptionTasksAPI/StopService?serviceType=${serviceType}&serviceID=${serviceID}`,stopDesc, onStopDone,"StopService");
}
/**
 * 
 * @param {string} serviceType 
 * @param {int} serviceID 
 * @param {function} onResumeDone 
 */
export function resumeService(serviceType, serviceID, onResumeDone)
{
  getMethodByCallBack(`ReceptionTasksAPI/ResumeService?serviceType=${serviceType}&serviceID=${serviceID}`, cacheTypes.NoCache, onResumeDone,"ResumeService");
}
export function serviceTurnaroundTime(dateFrom, dateTo)
{
  return dispatch => dispatch(
  getMethodByDispatcher(`api/ServiceReportsAPI/ServiceTurnaroundTime?dateFrom=${dateFrom}&dateTo=${dateTo}`,"SERVICE_TURNAROUND", cacheTypes.NoCache, "مدت زمان گردش کار"));
}
export function getServiceReferListForAgentPanel(onGet){
  getMethodByCallBack("api/UserDashboardAPI/GetServiceReferListForAgentPanel", cacheTypes.NoCache, onGet, "GetServiceReferListForAgentPanel");
}
export function getServiceIDByNumber(serviceType, invoiceNumber, onGet)
{
  getMethodByCallBack(`ReceptionTasksAPI/GetServiceIDByNumber?serviceType=${serviceType}&invoiceNumber=${invoiceNumber}`, cacheTypes.NoCache, onGet);
}
export function getSerialHistoryReport(data)
{
  return dispatch =>{
    dispatch({
      type:"SERIAL_H_REP_FILTERS",
      data: data
    });
    dispatch(postMethodByDispatcher("api/GuarantyAPI/GetSerialHistoryReport", data, "SERIAL_HISTORY_REPORT", "گزارش تاریخچه سریالها"));
  }
}
export function saveServiceBatch(data, onSave)
{
  postMethodByCallBack(`ReceptionTasksAPI/SaveServiceBatch`, data, onSave,"SaveServiceBatch");
}